import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStepForward } from '@fortawesome/free-solid-svg-icons';

interface Props {
  onClick: VoidFunction;
}

const ErrorNav: React.FC<Props> = ({ onClick }) => {
  return (
    <div className="error_nav" onClick={onClick}>
      <FontAwesomeIcon icon={faStepForward} className="fa-step-forward" />
      <div className="error_nav_text">次のエラー項目へ</div>
    </div>
  );
};

export default ErrorNav;
